import * as React from 'react'
import { connect } from 'react-redux';
import { Image } from 'react-bootstrap';
import './ProfileNav.css'

class ProfileNavMobile extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            hour: null,
        };

        this.componentDidMount = this.componentDidMount.bind(this);
        this.getHour = this.getHour.bind(this);
    }

    componentDidMount() {
        this.getHour()
    }

    getHour = () => {
        const date = new Date();
        const hour = date.getHours()
        this.setState({
            hour
        });
    }

    render() {
        const { hour } = this.state;
        const { firebase, profile } = this.props;
        let defaultImage = "./Images/Avatar/male-robot.png"
        if (profile.gender === "F") {
            defaultImage = "./Images/Avatar/female-robot.png";
        }

        return (
            <div className="profile-nav-mobile mb-5" id="GreetingBox">
                <div className="container">
                    <div className="d-lg-block d-xl-block d-md-block d-sm-none">
                        <div className="row pt-4">
                            <div className="col-3">
                                <Image className="profile-image-mobile" src={firebase.auth.photoURL ? firebase.auth.photoURL : defaultImage} />
                            </div>
                            <div className="col-9">
                                <p className="mb-0">{hour < 12 ? 'Good morning' : (hour >= 12 && hour < 18) ? 'Good afternoon' : 'Good evening'}</p>
                                <h3 className="user text-left">{profile.name}</h3>
                            </div>
                        </div>
                        <div className="line"></div>
                        <div className="row pt-3">
                            <div className="col-6 pr-0">
                                <label className="policyNumber mb-0">No. of policies</label>
                                <p className="policies">{profile.activePolicies} Active</p>
                            </div>
                            <div className="col-6 pl-0 text-right">
                                <label className="policyNumber mb-0">Next debit date</label>
                                <p className="debit">{profile.selectedPersonalPolicy !== undefined && profile.selectedPersonalPolicy.nextDebitOrderDate}</p>
                            </div>
                        </div>
                    </div>
                    <div className="d-lg-none d-xl-none d-md-none d-sm-block d-xs-none d-none">
                        <div className="row pt-4 mt-5">
                            <div className="col-3">
                                <Image className="profile-image-mobile" src={firebase.auth.photoURL ? firebase.auth.photoURL : defaultImage} />
                            </div>
                            <div className="col-9">
                                <p className="mb-0">{hour < 12 ? 'Good morning' : (hour >= 12 && hour < 18) ? 'Good afternoon' : 'Good evening'}</p>
                                <h3 className="user text-left">{profile.name}</h3>
                            </div>
                        </div>
                        <div className="line"></div>
                        <div className="row pt-3">
                            <div className="col-6 pr-0">
                                <label className="policyNumber mb-0">No. of policies</label>
                                <p className="policies">{profile.activePolicies} Active</p>
                            </div>
                            <div className="col-6 pl-0 text-right">
                                <label className="policyNumber mb-0">Next debit date</label>
                                <p className="debit">{profile.selectedPersonalPolicy !== undefined && profile.selectedPersonalPolicy.nextDebitOrderDate}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        firebase: state.firebase,
        profile: state.profile
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfileNavMobile);